<template>
    <nav class="navbar navbar-expand-lg navbar-dark navbar-orange d-lg-none" id="secondary-menu">
        <a class="navbar-brand" href="#">
            <img src="images/bitacorapp-logo-white.png" class="shatter-logo-navbar" alt="">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent1" aria-controls="navbarSupportedContent1" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        
        <div class="collapse navbar-collapse" id="navbarSupportedContent1" v-if="showMenu">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item dropdown" v-for="m in menu" :key="m.id">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ m.name }}
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <router-link v-for="item in getMenuOptions(m)" :to="{ name: item.to }" class="dropdown-item my-2" :key="item.id">
                            {{ item.name }}
                        </router-link>
                    </div>
                </li>
                <li class="nav-item dropdown mr-auto">
                    <a class="nav-link menu-item dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-user-circle-o" aria-hidden="true"></i> {{ user.name }}
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a v-if="shiftActive" class="dropdown-item" href="#" @click.prevent="$router.push({ name: 'shiftEndPage' })"><i class="fa fa-sign-out" aria-hidden="true"></i> Entregar turno</a>
                        <a v-if="isAuthenticated" class="dropdown-item" href="#" @click.prevent="accountPage"><i class="fa fa-user" aria-hidden="true"></i> Cuenta</a>
                        <a class="dropdown-item" href="#" @click.prevent="logOut"><i class="fa fa-sign-out" aria-hidden="true"></i> Salir</a>
                        <a class="dropdown-item" href="#" @click.prevent="updateSystem"><i class="fa fa-refresh" aria-hidden="true"></i> Actualizar</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'secondary_menu',
    computed: {
        ...mapGetters(['menu', 'allMenuOptions', 'alarms', 'shift', 'menuOptions']),
        calcular() {
            return 'calculo';
        },
        showMenu(){
            if(this.user.profile.slug !== 'vigilante') return true;

            return !!this.shift;
        },
        shiftActive(){
            return !!this.shift && this.user.profile.slug === 'vigilante';
        }
    },
    methods: {
        ...mapActions(['logOut']),
        getMenuOptions(menu) {
            return this.allMenuOptions.filter(item => item.menu.slug === menu.slug);
        },
        accountPage(){
            this.$router.push({
                name: 'accountPage'
            });
        },
        updateSystem() {
            window.location.reload(true);
        }
    }
}
</script>